import { useCallback } from 'react';
import { create } from 'zustand';
import { PageTabs } from './data';

const removeExhibitor = ({ id, arr }) =>
  arr?.filter((e) => e.salesforceId !== id);

const removeExhibitorsFromFolder = ({ folderId, exhibitors, arr }) => {
  const _arr = [...arr];
  const foundIdx = arr.findIndex((f) => f.folderId === folderId);
  if (foundIdx >= 0) {
    _arr[foundIdx].exhibitors = arr[foundIdx].exhibitors?.filter(
      (id) => !exhibitors.includes(id)
    );
    return _arr;
  } else {
    return arr;
  }
};

const addExhibitor = ({ exhibitor, arr }) => [...arr, exhibitor];

const addFolder = ({ folderId, name, exhibitors, arr }) => [
  ...arr,
  { folderId, name, exhibitors: exhibitors?.length ? exhibitors : [] },
];

const removeFolder = ({ folderId, arr }) =>
  arr?.filter((f) => f.folderId !== folderId);

const renameFolder = ({ folderId, newName, arr }) => {
  const _arr = [...arr];
  const foundIdx = arr.findIndex((f) => f.folderId === folderId);
  if (foundIdx >= 0) {
    _arr[foundIdx].name = newName;
    return _arr;
  } else {
    return arr;
  }
};

const moveExhibitorsToFolder = ({ folderId, exhibitorIds, arr }) => {
  const selectedFolderIdx = arr.findIndex((f) => f.folderId === folderId);
  if (selectedFolderIdx >= 0) {
    arr[selectedFolderIdx].exhibitors = [
      ...arr[selectedFolderIdx].exhibitors,
      ...exhibitorIds,
    ];
    exhibitorIds.map((exhibitorId) => {
      const foundInOtherFolderIdx = arr.findIndex(
        (f) => f.exhibitors.includes(exhibitorId) && f.folderId !== folderId
      );
      if (foundInOtherFolderIdx >= 0) {
        arr[foundInOtherFolderIdx].exhibitors = arr[
          foundInOtherFolderIdx
        ].exhibitors.filter((fId) => fId !== exhibitorId);
      }
    });
    return arr;
  } else {
    return [];
  }
};

const changeStatus = ({ exhibitor, newStatus, arr }) => {
  const found = arr.find((exh) => exh.salesforceId === exhibitor.salesforceId);
  found.status = newStatus;
  return [
    ...arr.filter((exh) => exh.salesforceId !== exhibitor.salesforceId),
    found,
  ];
};

const storeUserId = (id) => {
  useStore.setState({
    loggedUserId: id,
  });
};

const storeCurrentTab = (tab) => {
  useStore.setState({
    currentStoreTab: tab,
  });
};

const storeSelectedExhibitors = (exhibitorIds) => {
  useStore.setState({
    selectedExhibitors: exhibitorIds,
  });
};

const storeSelectedFolder = (folder) => {
  useStore.setState({
    selectedFolder: folder,
  });
};

const storeIsSavingToFolder = (bool) => {
  useStore.setState({
    isSavingToFolder: bool,
  });
};

const useStore = create((set) => ({
  exhibitorsManage: [],
  folders: [],
  selectedExhibitors: [],
  isSavingToFolder: true,
  currentStoreTab: PageTabs.EXHIBITORS,
  isEditing: false,
  cardsToManage: [],
  selectedFolder: {},
  currentFolderOnView: null,
  alertData: null,
  loggedUserId: '',
  removeExhibitorFromStore: ({ id }) =>
    set((state) => ({
      ...state,
      exhibitorsManage: removeExhibitor({
        id,
        arr: state.exhibitorsManage,
      }),
    })),
  addExhibitorToStore: ({ exhibitor }) =>
    set((state) => ({
      ...state,
      exhibitorsManage: addExhibitor({
        exhibitor,
        arr: state.exhibitorsManage,
      }),
    })),
  addFolderToStore: ({ folderId, name, exhibitors }) =>
    set((state) => ({
      ...state,
      folders: addFolder({
        folderId,
        name,
        exhibitors,
        arr: state.folders,
      }),
    })),
  removeFolderFromStore: ({ folderId }) =>
    set((state) => ({
      ...state,
      folders: removeFolder({
        folderId,
        arr: state.folders,
      }),
    })),
  removeExhibitorsFromFolderInStore: ({ folderId, exhibitors }) =>
    set((state) => ({
      ...state,
      folders: removeExhibitorsFromFolder({
        exhibitors,
        folderId,
        arr: state.folders,
      }),
    })),
  renameFolderInStore: ({ folderId, newName }) =>
    set((state) => ({
      ...state,
      folders: renameFolder({
        folderId,
        newName,
        arr: state.folders,
      }),
    })),
  moveExhibitorsToFolderInStore: ({ folderId, exhibitorsIds }) =>
    set((state) => ({
      ...state,
      folders: moveExhibitorsToFolder({
        folderId,
        exhibitorIds: exhibitorsIds,
        arr: state.folders,
      }),
    })),
  changeExhibitorStatus: ({ exhibitor, newStatus }) =>
    set((state) => ({
      ...state,
      exhibitorsManage: changeStatus({
        exhibitor,
        newStatus,
        arr: state.exhibitorsManage,
      }),
    })),
  emptyArray: () =>
    set((state) => ({
      ...state,
      exhibitorsManage: [],
    })),
}));

const useBookmarkSelector = () => useStore(useCallback((state) => state, []));

export {
  useBookmarkSelector,
  storeUserId,
  storeCurrentTab,
  storeSelectedExhibitors,
  storeSelectedFolder,
  storeIsSavingToFolder,
  useStore as useBookmarkStore,
};
